<div class="flex" [ngClass]="{ 'gap-2': isEligibleVoter }">
  <span class="text-m material-symbols-rounded" [ngStyle]="{'color': colorClass}" id="sd-vote-selection-icon">{{
    iconName }}</span>

  <button *ngIf="hasComment" (click)="openPopover(commentPopover)">
    <ng-container *ngIf="isEligibleVoter; else ineligiblePopover">
      <app-view-votes-popover
        #commentPopover
        id="sd-vote-comment-popover"
        popoverTitle="Ballot Comment"
        [votePopoverItems]="voteCommentPopoverItems">
      </app-view-votes-popover>
    </ng-container>

    <ng-template #ineligiblePopover>
      <app-view-votes-popover-ineligible
        #commentPopover
        id="sd-vote-comment-popover-ineligible"
        popoverTitle="Ballot Comment"
        [votePopoverItems]="voteCommentPopoverItems">
      </app-view-votes-popover-ineligible>
    </ng-template>

    <span
      [class]="ViewVoteIconsConstants.chatBubble.colorClass"
      class="text-m material-symbols-rounded text-darkBlue-600 cursor-pointer"
      id="sd-vote-comment-icon">
      {{ ViewVoteIconsConstants.chatBubble.iconName }}
    </span>
  </button>

  <button *ngIf="showingDocumentIcon" (click)="openVoteDocumentsPopover(voteDocumentsPopover)">
    <app-votes-documents-popover
      #voteDocumentsPopover
      id="sd-vote-documents-popover"
      popoverTitle="Authorisation Documents"
      ballotType="{{BallotType}}"
      ballotId="{{vote?.ballotRecordId}}"
      voteId="{{vote?.ballotVoteId}}"
    ></app-votes-documents-popover>
    <span
      [class]="ViewVoteIconsConstants.draft.colorClass"
      class="text-blue-500 text-m material-symbols-rounded"
      id="sd-vote-document-icon">
      {{ ViewVoteIconsConstants.draft.iconName }}
    </span>
  </button>

  <span *ngIf="hasDocument" [class]="ViewVoteIconsConstants.howToVote.colorClass"
    class="text-m material-symbols-rounded text-grey-800" id="sd-vote-proxy-vote-icon">
    {{ ViewVoteIconsConstants.howToVote.iconName }}
  </span>
  <button *ngIf="hasHistories" (click)="openPopover(historyPopover)">
    <app-view-votes-popover
      #historyPopover
      id="sd-vote-history-popover"
      popoverTitle="Vote History"
      [votePopoverItems]="voteHistoryPopoverItems">
    </app-view-votes-popover>
    <span *ngIf="hasHistories" [class]="ViewVoteIconsConstants.history.colorClass"
      class="text-m material-symbols-rounded text-grey-800" id="sd-vote-history-icon">
      {{ ViewVoteIconsConstants.history.iconName }}
    </span>
  </button>
</div>
